import { put, call } from 'redux-saga/effects';
import { getSAProfileDetails, updateSAProfileDetails } from '../services/superAdminService';

import * as types from '../actions';


export function* getSAProfileDetailsSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(getSAProfileDetails, payload);
    yield put({ type: types.SA_PROFILE_DETAILS_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.SA_PROFILE_DETAILS_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* updateSAProfileDetailsSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(updateSAProfileDetails, payload);
      yield put({ type: types.SA_PROFILE_DETAILS_UPDATE_SUCCESS, response })
            
    } catch(error) {
      yield put({ type: types.SA_PROFILE_DETAILS_UPDATE_ERROR, error });
    }finally{
        yield put({ type: types.HIDE_LOADER})
    }
  }

